
<template>
    <header :data-test-id="`header-${brandWord}`">
        <img v-if="brandWord === 'Citroen'" src='../../src/assets/iown-logo-citroen.jpg' alt="IOWN Citroen logo" class="header_logo" />
        <img v-if="brandWord === 'Peugeot'" src='../../src/assets/iown-logo1.png' alt="IOWN Peugeot logo" class="header_logo" />
        <img v-if="brandWord === 'Opel'" src='../../src/assets/iown-logo1.png' alt="IOWN Opel logo" class="header_logo" />
    </header>
</template>

<script>

export default {
  name: 'HeaderComponent',
  props: {
    brandWord: {
      type: String,
      default: 'Peugeot'
    }
  }
}

</script>

<style scoped>
</style>
